/**
 * Legacy `QuickCodeForm` behavior: numeric codes → ###-###-####, alphanumeric → ####-####-…
 * CRM lookup and payloads use the formatted value (with dashes), same as `registrationStore.quickCode`.
 */
const NUMERIC_QUICK_CODE_MAX_DIGITS = 10;
/** Legacy `maxLength={15}` display = 13 alphanumerics + 2 dashes (e.g. APQ1-7899-59MAP). */
const ALPHANUMERIC_QUICK_CODE_MAX_CHARS = 13;

export function formatQuickCodeInput(raw: string): string {
  const alnum = raw.toUpperCase().replace(/[^0-9A-Z]/g, "");
  if (!alnum) return "";
  if (/^\d/.test(alnum)) {
    const digits = alnum.replace(/\D/g, "").slice(0, NUMERIC_QUICK_CODE_MAX_DIGITS);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  const a = alnum.slice(0, ALPHANUMERIC_QUICK_CODE_MAX_CHARS);
  const p1 = a.slice(0, 4);
  const p2 = a.slice(4, 8);
  const p3 = a.slice(8);
  return [p1, p2, p3].filter((p) => p.length > 0).join("-");
}

/** Value sent to POST /api/buxus/get-by-quickcode-computed (formatted with dashes). */
export function quickCodeForLookup(formatted: string): string {
  return formatted.trim().toUpperCase();
}

export function quickCodeAlphanumericsOnly(formatted: string): string {
  return formatted.toUpperCase().replace(/[^0-9A-Z]/g, "");
}

export function hasQuickCodeInput(formatted: string): boolean {
  return quickCodeAlphanumericsOnly(formatted).length > 0;
}
